import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/base/ComicCard';
import { comics, categories } from '@/mocks/comics';

export default function Home() {
  const [heroBgIndex, setHeroBgIndex] = useState(0);
  const heroImages = [
    'https://readdy.ai/api/search-image?query=A%20vibrant%20anime%20and%20manga%20themed%20abstract%20composition%2C%20dynamic%20color%20splashes%20in%20warm%20orange%20coral%20and%20golden%20tones%2C%20comic%20halftone%20dots%20and%20manga%20speed%20lines%2C%20artistic%20illustration%20texture%20with%20Japanese%20and%20Korean%20comic%20art%20influences%2C%20energetic%20and%20modern%20design%2C%20clean%20composition%20with%20abstract%20geometric%20manga%20elements&width=1600&height=700&seq=pipi-hero-01&orientation=landscape',
    'https://readdy.ai/api/search-image?query=A%20warm%20and%20artistic%20manga%20reading%20atmosphere%20composition%2C%20soft%20watercolor%20style%20with%20floating%20comic%20pages%20and%20ink%20brush%20strokes%2C%20warm%20amber%20and%20coral%20gradient%20background%2C%20subtle%20Japanese%20wave%20patterns%20and%20cherry%20blossom%20silhouettes%2C%20dreamy%20and%20inviting%2C%20clean%20artistic%20composition&width=1600&height=700&seq=pipi-hero-02&orientation=landscape',
    'https://readdy.ai/api/search-image?query=An%20energetic%20modern%20comic%20and%20manga%20collage%20style%2C%20layered%20translucent%20panels%20with%20action%20lines%2C%20warm%20coral%20and%20golden%20gradient%20overlay%2C%20abstract%20speech%20bubbles%20and%20comic%20effects%2C%20digital%20art%20aesthetic%2C%20clean%20and%20dynamic%20composition%20on%20neutral%20warm%20background&width=1600&height=700&seq=pipi-hero-03&orientation=landscape',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setHeroBgIndex((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const hotComics = comics.filter(c => c.isHot).slice(0, 6);
  const newComics = comics.filter(c => c.isNew);
  const allComics = comics.slice(0, 12);

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': '皮皮漫画-皮皮漫画韩漫与皮皮漫画日漫|皮皮漫画国漫类型大全',
    'description': '皮皮漫画🎯提供韩漫、日漫、国漫等多种类型漫画在线免费阅读。按类型筛选热门作品，🎉皮皮漫画韩漫、皮皮漫画日漫专区一应俱全。',
    'url': 'https://pipicomics.com',
    'inLanguage': 'zh-CN',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': '皮皮漫画可以免费阅读吗？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '是的！皮皮漫画所有的皮皮漫画韩漫、皮皮漫画日漫和皮皮漫画国漫都提供完全免费的在线阅读服务，无需付费即可畅享所有内容。',
        },
      },
      {
        '@type': 'Question',
        'name': '皮皮漫画有哪些漫画类型？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '皮皮漫画提供丰富的皮皮漫画类型大全，包括皮皮漫画韩漫、皮皮漫画日漫、皮皮漫画国漫等多种类型。用户可以在皮皮漫画类型分类页面按恋爱、热血、奇幻、战斗、校园、搞笑、修仙、冒险等标签筛选喜欢的作品。',
        },
      },
      {
        '@type': 'Question',
        'name': '皮皮漫画更新频率怎么样？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '皮皮漫画每日更新热门漫画，确保读者能够第一时间追到最新话。热门作品基本保持每周更新，部分高人气作品甚至能做到隔日更新。',
        },
      },
      {
        '@type': 'Question',
        'name': '皮皮漫画支持哪些设备阅读？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '皮皮漫画支持电脑、平板和手机等多种设备的在线阅读。网页采用响应式设计，在任何屏幕上都能获得优质的皮皮漫画在线阅读体验。',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <Navbar />

      <main>
        <section className="relative h-[420px] md:h-[580px] overflow-hidden">
          {heroImages.map((img, i) => (
            <div
              key={i}
              className="absolute inset-0 transition-opacity duration-1000"
              style={{ opacity: i === heroBgIndex ? 1 : 0 }}
            >
              <img
                src={img}
                alt="皮皮漫画"
                className="w-full h-full object-cover"
              />
            </div>
          ))}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
              皮皮漫画
            </h1>
            <p className="text-sm md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
              皮皮漫画韩漫、皮皮漫画日漫、皮皮漫画国漫类型大全 ——
              <strong className="text-accent-400 font-semibold">免费在线阅读</strong>，每日更新，高清画质
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-lg">
              <div className="relative w-full">
                <input
                  type="text"
                  placeholder="搜索你喜欢的漫画..."
                  className="w-full pl-10 pr-4 py-3 text-sm bg-white/95 rounded-full focus:outline-none focus:ring-2 focus:ring-primary-400 text-foreground-800"
                />
                <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500"></i>
              </div>
              <Link
                to="/category/kr"
                className="whitespace-nowrap px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors"
              >
                开始阅读
              </Link>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                漫画分类
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {categories.filter(c => c.key !== 'all').map((cat) => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.key}`}
                  className="group relative overflow-hidden rounded-lg bg-background-100 p-5 hover:bg-primary-500 transition-all duration-300"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-400 group-hover:text-background-50 transition-all duration-300 mb-3">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-background-50 transition-colors">
                    皮皮漫画{cat.label}
                  </h3>
                  <p className="text-xs text-foreground-500 group-hover:text-background-200 transition-colors mt-1">
                    海量{cat.label}免费阅读
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  热门推荐
                </h2>
              </div>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1"
              >
                更多热门 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 md:gap-5" data-product-shop>
              {hotComics.map(comic => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>
        </section>

        {newComics.length > 0 && (
          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                    最新上架
                  </h2>
                </div>
                <Link
                  to="/category/all"
                  className="text-sm text-accent-500 hover:text-accent-600 transition-colors flex items-center gap-1"
                >
                  更多新作 <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 md:gap-5" data-product-shop>
                {newComics.map(comic => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            </div>
          </section>
        )}

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-1 h-5 bg-secondary-500 rounded-full"></div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  全部漫画
                </h2>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 md:gap-5" data-product-shop>
              {allComics.map(comic => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
              关于皮皮漫画
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              皮皮漫画是一个专注于<strong>皮皮漫画韩漫</strong>、<strong>皮皮漫画日漫</strong>和<strong>皮皮漫画国漫</strong>的在线免费阅读平台。
              我们致力于为广大漫画爱好者提供最全面的<strong>皮皮漫画类型大全</strong>，涵盖恋爱、热血、奇幻、战斗、校园、搞笑、修仙、冒险等多种类型。
              无论你喜欢什么风格的漫画，在<strong>皮皮漫画免费</strong>在线阅读都能找到心仪的作品。每日更新热门漫画，让您的<strong>皮皮漫画在线阅读</strong>体验更加畅快！
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-1 px-6 py-3 bg-secondary-500 text-background-50 text-sm font-medium rounded-full hover:bg-secondary-600 transition-colors"
            >
              了解更多关于我们 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
              常见问题
            </h2>
            <div className="space-y-3">
              {faqSchema.mainEntity.map((faq, idx) => (
                <details key={idx} className="group bg-background-50 rounded-lg p-5 cursor-pointer">
                  <summary className="text-sm md:text-base font-medium text-foreground-800 list-none flex items-center justify-between">
                    {faq.name}
                    <i className="ri-add-line group-open:ri-subtract-line text-foreground-500 transition-all"></i>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    {faq.acceptedAnswer.text}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}